"use strict";

const UrlImport = function () {
  var $mount;
  var layer;
  var _url;

  var validateHandler = function () {
    throw "validateHandler is not set";
  };

  var loadListeners = function () {
    $mount.off("input", `[name="url-input"]`, handleValidateButtonToggle);
    $mount.on("input", `[name="url-input"]`, handleValidateButtonToggle);

    $mount.off("keypress", handleFormSubmit);
    $mount.on("keypress", handleFormSubmit);
  };

  var handleValidateButtonToggle = function (e) {
    const disableState = $(e.currentTarget).val().length === 0;
    Misc.toggleDisabled($("#import-modal .import-next-button"), disableState);
  };

  var handleFormSubmit = function (e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      validateUrl();
      return false;
    }
  };

  var validateUrl = function () {
    const urlRegex = DataImportConfig.validationRegex[layer];
    const urlTester = new RegExp(urlRegex);
    const url = $mount.find(`[name="url-input"]`).val();

    if (urlTester.test(url)) {
      validateHandler(url);
    } else {
      showWarningModal("wrongUrl");
    }
  };

  var _setUrl = function (newUrl) {
    _url = newUrl;
  };

  var queryArcGisUrl = async function (url) {
    const queryUrl = new URL(url);
    queryUrl.pathname += "/query";
    _setUrl(queryUrl);
    showUrlImportModal();
    try {
      await DataImportPreview.loadUrlImportPreview(queryUrl.toString());
    } catch (e) {
      const responseJson = e?.xhrResponse?.responseJSON;
      showWarningModal(responseJson?.errorType ?? "serverError", responseJson?.message);
    }
  };

  var showUrlImportModal = function () {
    DataImport.setCurrentPage("url-import");
    toggleUrlModal();
  };

  var toggleUrlModal = function () {
    const $importModal = $("#import-modal");
    $importModal.find(".import-next-button").hide();
    $importModal.find(".url-validator").hide();
    $importModal.find(".import-button").show();
    $importModal.find(".url-upload").show();
    DataImport.toggleWideImportModal(true);
  };

  var init = function (layerToImport, mapLayer, newHandler) {
    layer = layerToImport;
    validateHandler = newHandler;
  };

  var show = function ($renderMount, toggleImportEnabledFn) {
    $mount = $renderMount;
    $mount.html(
      nunjucks.render("dataImport/urlImport.njk", { inputText: DataImportConfig.modalBody[layer] }),
    );
    loadListeners();

    DataImportPreview.init(layer, $renderMount.find("#import-preview"), toggleImportEnabledFn);
    DataImportPreview.loadPreviewListeners();
  };

  var showWarningModal = function (warningType, message) {
    const warning = DataImportConfig.errorMessages[layer][warningType];
    MessageModal.showWarningModal(message ?? warning.message, warning.title);
    $mount.find(`[name="url-input"]`).val("");
  };

  var importValidatedUrl = async function () {
    try {
      const fieldMapping = DataImportPreview.getFieldMapping();
      const urlString = _url.toString();
      const importCount = await ApiCalls.importValidatedUrl(urlString, fieldMapping, layer);
      $mount.html(
        nunjucks.render("dataImport/done.njk", {
          created: importCount,
        }),
      );
      // @TODO fix up refresh layer for url imports
      //LayerDataFunctions.refreshLayer(mapLayerToRefresh, "main");
    } catch (e) {
      $mount.html(nunjucks.render("dataImport/fail.njk"));
      console.error(e);
    } finally {
      DataImport.setCurrentPage("import-finished");

      $("#import-modal .import-button").hide();
    }
  };

  return {
    init,
    showUrlImportModal,
    show,
    _setUrl,
    validateUrl,
    queryArcGisUrl,
    showWarningModal,
    importValidatedUrl,
  };
};

module.exports = UrlImport();

const ApiCalls = require("../apiCalls");
const DataImport = require("./dataImport");
const DataImportConfig = require("../config/dataImportConfig");
const DataImportPreview = require("./dataImportPreview");
const Misc = require("../misc");
const MessageModal = require("../modals/messageModal");
